module.exports = __webpack_public_path__ + "img/thompson.de322a8d.jpg";